
import { Injectable, Inject } from '@angular/core';
import { HttpService } from './http.service';
import { HttpErrorResponse, HttpHeaders, HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { from, interval } from 'rxjs';
import { Observable, throwError } from 'rxjs';
import { catchError, retryWhen, switchMap, finalize } from 'rxjs/operators'; // ⬅️ added finalize
import { MSAL_INSTANCE } from '@azure/msal-angular';
import { HandleErrorService } from './handle-error.service';
import { LoaderService } from './loader-service'; // ⬅️ added
@Injectable({
  providedIn: 'root'
})
export class AuthInterceptor implements HttpInterceptor {
  maxTries = 3;
  delayBetweenTries = 1000;
  errorMessage;
  constructor(private http: HttpService,@Inject(MSAL_INSTANCE) private msalInstance: any,private error: HandleErrorService,private loader: LoaderService) {
    this.msalInstance = msalInstance;
  }
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    var username = localStorage.getItem('accountid');
    var currentAccount = this.msalInstance.getAllAccounts().find(acc => acc.username === username);
    const isGraphQL = req.url.includes('graphql');
    const skipLoader = req.headers.get('x-loader') === 'off';
    if (isGraphQL && !skipLoader) {
      this.loader.show();
    }
    return from(this.msalInstance.initialize())
      .pipe(
        switchMap(() => {
          var silentRequest = {
            scopes: ['user.read'],
            account: currentAccount,
            forceRefresh: false
          };
          return from(
            this.msalInstance
              .acquireTokenSilent(silentRequest)
              .then(function (response) {
                localStorage.setItem('resToken', response.idToken);
                return response.idToken;
              })
              .catch((error) => {
                return this.msalInstance
                  .acquireTokenRedirect(silentRequest)
                  .then(function (tokenResponse) {
                    localStorage.setItem('resToken', tokenResponse.idToken);
                    return tokenResponse.idToken;
                  })
                  .catch(function (error) {
                    console.log(error);
                  });
              })
          );
        })
      )
      .pipe(
        switchMap((data) => {
          let userDetails = JSON.parse(sessionStorage.getItem('clientData'));
          let authReq;

          if (req.url.includes('yaml')) {
            authReq = req.clone({
              headers: new HttpHeaders({
                Authorization: 'Bearer ' + data,
                'Content-Type': 'application/x-yaml'
              })
            });
          } else if (req.url.includes('import-json')) {
            authReq = req.clone({
              headers: new HttpHeaders({
                Authorization: 'Bearer ' + data,
                'Content-Type': 'application/json'
              })
            });
          } else if (req.url.includes('graphql')) {
            authReq = req.clone({
              headers: req.headers
                .set('Authorization', 'Bearer ' + data)
                .set('X-Hasura-Tenant-Name', userDetails?.tenantNm)
                .set('X-Hasura-Role', 'write')
                .set('Content-Type', 'application/json')
            });
          } else {
            authReq = req.clone({
              headers: new HttpHeaders({
                Authorization: 'Bearer ' + data
              })
            });
          }

          // send cloned request with header to the next handler.
          return next.handle(authReq).pipe(
            catchError((err: HttpErrorResponse) => {
              return throwError(this.error.handleError(err));
            }),
            finalize(() => {
              if (isGraphQL && !skipLoader) {
                this.loader.hide();
              }
            })
          );
        }),
        catchError((err) => {
          if (isGraphQL && !skipLoader) {
            this.loader.hide();
          }
          return throwError(err);
        })
      );
  }
}
